module.exports = __webpack_public_path__ + "img/20200609_140513.9bec7785.jpg";